import React, { useEffect, useState } from "react";
import styles from "./PasswordRecreate.module.scss";
import TextForm, { TextFormResult } from "../../atoms/text-form/TextForm";
import { validators } from "../../common/utility/validator.util";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { passwordRecreate } from "../../api/PasswordApi";
import { fetchPasswordConfirm } from "../../api/PasswordConfirmApi";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../molecules/header/Header";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import iconOpenEye from "../../static/images/iconOpenEye.svg";
import iconCloseEye from "../../static/images/iconCloseEye.svg";

const PasswordRecreate = () => {
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  const navigator = useNavigate();

  const [primaryPassword, setPrimaryPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState<string>();  

  const passwordConfirmApi  = fetchPasswordConfirm();
  const passwordRecreateApi = passwordRecreate();

  const onClick = () => {
    if (email == null || token == null) {
      navigator("/expire-token");
    } else {
      passwordRecreateApi.post({
        email: email,
        password: confirmPassword,
        token: token,
      });
    }
  };

  useEffect(() => {
    if (token == null) {
      navigator("/login");
    } else {
      passwordConfirmApi.fetch({ token });
    }
  }, []);

  useEffect(() => {
    if (passwordConfirmApi?.state?.status === "error") {
      navigator("/token-expire");
    }
  
    if (passwordConfirmApi?.state?.status === "success") {
      setEmail(passwordConfirmApi?.state?.data?.[0].email);
    }
  }, [passwordConfirmApi]);
    
  useEffect(() => {
    if (passwordRecreateApi.state?.status === "success") {
      navigator("/login");
    }
  }, [passwordRecreateApi.state?.status]);

  const passwordValidator = (value: string) => {
    const requiredResult = validators.required(value);

    if (!requiredResult.status) {
      return requiredResult;
    }

    const passwordResult = validators.password(value);

    if (!passwordResult.status) {
      return passwordResult;
    }

    return { status: true };
  };

  const confirmPasswordValidator = (value: string) => {
    const result = passwordValidator(value);
    if (!result.status) return result;

    if (value !== primaryPassword) {
      return { status: false, message: "パスワードが一致しません" };
    }

    return { status: true };
  };


  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <Header hideMenu={true} />
        <div className={styles.title}>パスワード再設定</div>
        <div className={styles.inputArea}>
          <div className={styles.input}>
            <TextForm
              name="primaryPassword"
              value={primaryPassword}
              color="white"
              label="パスワード"
              inputWidth="100%"
              type={showPassword ? "text" : "password"}
              rightIcon={showPassword ? iconOpenEye : iconCloseEye}
              onClickRightButton={() => setShowPassword(!showPassword)}
              onChange={(args: TextFormResult) => setPrimaryPassword(args.value)}
              validator={passwordValidator}
            ></TextForm>
          </div>
          <div className={styles.input}>
            <TextForm
              name="confirmPassword"
              value={confirmPassword}
              color="white"
              label="パスワード再入力"
              inputWidth="100%"
              type={showPassword ? "text" : "password"}
              rightIcon={showPassword ? iconOpenEye : iconCloseEye}
              onClickRightButton={() => setShowPassword(!showPassword)}
              onChange={(args: TextFormResult) => setConfirmPassword(args.value)}
              validator={confirmPasswordValidator}
            ></TextForm>
          </div>
          <div className={styles.buttonArea}>
            <SimpleButton
              label="パスワードを再設定する"
              width="100%"
              isRadius={true}
              onClick={onClick}
              disabled={
                !passwordValidator(primaryPassword).status ||
                !passwordValidator(confirmPassword).status ||
                primaryPassword !== confirmPassword
              }
            ></SimpleButton>
          </div>
        </div>
      </div>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル", url: "/home" },
          { displayName: "パスワード再設定"},
        ]}
      />
    </div>
  );
};

export default PasswordRecreate;